import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { HiExclamation } from 'react-icons/hi';

export const ImpersonationBanner: React.FC = () => {
  const { currentUser, endImpersonation, isImpersonating } = useAuth();
  const navigate = useNavigate();

  if (!isImpersonating || !currentUser) return null;

  const handleEndImpersonation = async () => {
    await endImpersonation();
    navigate('/admin/users');
  };

  return (
    <div className="bg-amber-500 dark:bg-amber-600 text-white px-4 py-2 flex items-center justify-between z-50">
      <div className="flex items-center space-x-2">
        <HiExclamation className="h-5 w-5 flex-shrink-0" />
        <span className="text-sm font-medium">
          You are viewing the application as{' '}
          <strong>{currentUser.name}</strong>{' '}
          ({currentUser.role})
        </span>
      </div>
      <button
        onClick={handleEndImpersonation}
        className="px-3 py-1 text-sm font-medium bg-white text-amber-700 hover:bg-amber-50 rounded transition-colors"
      >
        End Impersonation
      </button>
    </div>
  );
};
